import { UNITS } from '../constants'

export default function getDistance(loc1, loc2, unit) {
  if (loc1.lat === loc2.lat && loc1.lng === loc2.lng) {
    return 0
  }
  let theta = loc1.lng - loc2.lng
  let rad = {
    lat1: (Math.PI * loc1.lat) / 180,
    lat2: (Math.PI * loc2.lat) / 180,
    theta: (Math.PI * theta) / 180,
  }
  let dist =
    Math.sin(rad.lat1) * Math.sin(rad.lat2) +
    Math.cos(rad.lat1) * Math.cos(rad.lat2) * Math.cos(rad.theta)
  if (dist > 1) {
    dist = 1
  }
  if (dist < -1) {
    dist = -1
  }
  dist = Math.acos(dist)
  dist = (dist * 180) / Math.PI
  dist = dist * 60 * 1.1515
  if (unit === UNITS.KM) {
    dist = dist * 1.609344
  }
  return dist
}
